// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2r2xx","insightsList":"newBusinessInsightsMenu_insightsList__3qW01","active":"newBusinessInsightsMenu_active__30h5M"};